import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#424242",
  "fill-rule": "evenodd",
  d: "M3.23 15.563a1.3 1.3 0 0 1-.961-.394 1.3 1.3 0 0 1-.394-.962V6.418q0-.569.394-.962a1.3 1.3 0 0 1 .962-.394h3.144V3.793q0-.569.394-.962.393-.393.962-.393h2.538q.57 0 .962.393.394.394.394.962v1.27h3.144q.57 0 .962.393.394.394.394.962v7.789q0 .569-.394.962a1.3 1.3 0 0 1-.962.393zm4.27-10.5h3v-1.27a.22.22 0 0 0-.072-.158.22.22 0 0 0-.159-.072H7.731a.22.22 0 0 0-.159.072.22.22 0 0 0-.072.158z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }